import {
  SESSION_COOKIE_CHUB_CURRENT_TENANT,
  SESSION_COOKIE_CHUB_SIGNED_TOKEN,
  SESSION_COOKIE_CHUB_USER,
  SESSION_COOKIE_NAME_CHUB
} from '~/core/constants/cookies'

type CookieMap = Partial<Record<string, string>>

/**
 * Parse CareerHub user cookie and require a usable user id.
 * Treats missing/"undefined"/"null"/invalid JSON/empty object as invalid.
 */
export function parseChubUserCookie(
  userCookie?: string
): { id: string | number; onboarding?: boolean } | null {
  if (!userCookie || userCookie === 'undefined' || userCookie === 'null') {
    return null
  }

  try {
    const user = JSON.parse(userCookie) as {
      id?: string | number | null
      onboarding?: boolean
    } | null
    if (!user || typeof user !== 'object' || user.id == null || user.id === '') {
      return null
    }
    return { id: user.id, onboarding: user.onboarding }
  } catch {
    return null
  }
}

/**
 * Complete session = session token + signed token + parsable user with id.
 */
export function hasCompleteChubSession(cookies: CookieMap): boolean {
  const sessionCookie = cookies[SESSION_COOKIE_NAME_CHUB]
  const signedTokenCookie = cookies[SESSION_COOKIE_CHUB_SIGNED_TOKEN]
  const userCookie = cookies[SESSION_COOKIE_CHUB_USER]

  if (!sessionCookie || !signedTokenCookie) {
    return false
  }

  return !!parseChubUserCookie(userCookie)
}

/**
 * Stale leftovers that can block magic-link login.
 * Does NOT include signedToken-only state (pending same-browser email verification).
 */
export function hasStaleChubSessionCookies(cookies: CookieMap): boolean {
  return !!(
    cookies[SESSION_COOKIE_NAME_CHUB] ||
    cookies[SESSION_COOKIE_CHUB_USER] ||
    cookies[SESSION_COOKIE_CHUB_CURRENT_TENANT]
  )
}
